import React, { useState } from 'react';

import { CameraAlt, ExpandMore } from '@mui/icons-material';
import {
  AccordionDetails,
  AccordionSummary,
  Button,
  Grid,
} from '@mui/material';

import { PRIMARY_GRAY } from 'commons/styles/colors';
import { STOCheckBasket } from 'commons/types';
import { RowTitleProps } from 'commons/types/listPageData.interface';

import { CheckBasketStyle as S } from '../STOCheckBasket.styles';

import { BasketInfoTable } from './BasketInfoTable.component';
import UploadPhotoModal from './UploadPhotoModal.component';

interface IBasketInfosProps {
  stoNumber: string;
  data?: STOCheckBasket;
  getTotalQtyBySkuCode: (skuCode: string) => number;
  disableContent: boolean;
}

const rowTitles: RowTitleProps[] = [
  { title: 'SKU ID' },
  { title: 'Name' },
  { title: 'UoM' },
  { title: 'Order QTY', isCentered: true },
  { title: 'QTY Checked', isCentered: true },
  { title: 'Box Number', isCentered: true },
  { title: 'Pallet Position', isCentered: true },
  { title: 'Mark as Passed', isCentered: true },
];

export const BasketInfos: React.FC<IBasketInfosProps> = ({
  stoNumber,
  data,
  getTotalQtyBySkuCode,
  disableContent,
}) => {
  const [isOpenPhotoModal, setIsOpenPhotoModal] = useState<boolean>(false);

  const handleOpenDialog = (e: React.MouseEvent<HTMLDivElement>): void => {
    e.stopPropagation();
    setIsOpenPhotoModal(true);
  };

  const handleCloseDialog = (): void => {
    setIsOpenPhotoModal(false);
  };
  return (
    <>
      <Grid container marginBottom="16px" spacing={0}>
        <Grid item xs={12}>
          <S.Accordion defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMore style={{ color: PRIMARY_GRAY }} />}
              aria-controls={`basket${data?.basket}-content`}
              id={`basket${data?.basket}-header`}
              style={{
                padding: '2px 12px 2px 12px',
                backgroundColor: '#D9D9D926',
              }}
            >
              <S.BasketInfoHeader>
                <div data-testid="checkingBasket">{`BASKET ${data?.basket}`}</div>
                <S.VerticalLine />
                <S.TakePhotoSection onClick={handleOpenDialog}>
                  {data?.photo_url.length === 0 ? (
                    <Button data-testid="takePhoto">
                      <CameraAlt /> TAKE PHOTO
                    </Button>
                  ) : (
                    <Button data-testid="viewPhoto">VIEW PHOTO</Button>
                  )}
                </S.TakePhotoSection>
              </S.BasketInfoHeader>
            </AccordionSummary>
            <AccordionDetails style={{ padding: '0' }}>
              <BasketInfoTable
                stoNumber={stoNumber}
                rowTitles={rowTitles}
                data={data?.items}
                basketNumber={data?.basket || 0}
                getTotalQtyBySkuCode={getTotalQtyBySkuCode}
                isDisabled={disableContent}
              />
            </AccordionDetails>
          </S.Accordion>
        </Grid>
      </Grid>
      <UploadPhotoModal
        openModal={isOpenPhotoModal}
        onClose={handleCloseDialog}
        stoNumber={stoNumber}
        basketNumber={data?.basket || 0}
        photos={data?.photo_url || []}
        isDisabled={disableContent}
      />
    </>
  );
};
